import React from "react";
import { Route, Redirect } from "react-router-dom";
import useAuthState from "../../hooks/useAuthState";
import useTutorialsState from "../../hooks/useTutorialsState";

function ProtectedRoute({
  path,
  exact,
  bootIntercom,
  trackPageVisitOnMixpanel,
  component: Component
}) {
  const { isLoggedIn } = useAuthState();
  const {
    hasCompletedOnboarding,
    getHasCompletedTutorial
  } = useTutorialsState();

  return (
    <Route
      path={path}
      exact={exact}
      render={(props) => {
        bootIntercom();
        trackPageVisitOnMixpanel(props);
        window.Intercom("update");
        const hasCompletedProfileStep = getHasCompletedTutorial(
          "Brand Dashboard Personal Info"
        );
        const hasCompletedImageAndBioStep = getHasCompletedTutorial(
          "Brand Dashboard Organization Info"
        );
        const hasCompletedPaymentInfoStep = getHasCompletedTutorial(
          "Brand Dashboard Payment Info"
        );

        if (isLoggedIn && hasCompletedOnboarding) {
          return <Component {...props} />;
        } else if (!isLoggedIn) {
          return <Redirect to="/login" />;
        } else if (hasCompletedProfileStep && !hasCompletedImageAndBioStep) {
          return <Redirect to="/register/organization" />;
        } else if (hasCompletedProfileStep && hasCompletedImageAndBioStep && !hasCompletedPaymentInfoStep) {
          return <Redirect to="/register/payment" />;
        } else {
          return <Redirect to="/register" />;
        }
      }}
    />
  );
}

export default ProtectedRoute;
